import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useState } from "react";
import Button from "components/Button";
import Avatar from "components/Avatar";
import { setWorkspaceId } from "utils/setWorkspaceId";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useCreateTeam } from "hooks/useCreateTeam";
import { ENotificationType, notification } from "utils/notification";
import TeamIcon from "assets/icons/team.svg?react";

const CreateWorkspace: FC<Props> = ({ onCreate }) => {
  const { t } = useTranslation();
  const auth = useAuth();
  // Podpowiedź nazwy zespołu z nazwy zalogowanego użytkownika (może nadpisać).
  const [value, setValue] = useState(() => auth.user?.profile?.name ?? "");
  const { createTeam, loading } = useCreateTeam();

  // Bieżący użytkownik prezentowany jako pierwszy (i jedyny) członek — właściciel zespołu.
  const currentUserName = auth.user?.profile?.name ?? "";

  const handleClick = async () => {
    if (loading) return;

    try {
      const workspaceId = await createTeam(value);
      setWorkspaceId(workspaceId);
      onCreate(workspaceId);
    } catch (e) {
      notification({
        type: ENotificationType.ERROR,
        title: t('errors.error'),
        text: t('errors.somethingWentWrong'),
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      {t("workspace.enterCompanyName")}
      <Input
        value={value}
        label={t("forms.companyOrInstitution")}
        onChange={(t) => setValue(t)}
      />
      <Button
        onClick={handleClick}
        text={t("common.save")}
        loading={loading}
        disabled={loading || !value}
      />
    </div>
  );
};

export default CreateWorkspace;
